import Suru from "../../../../suru/js/app";

$(document).on('data-layer-push-ajax-page', function(){
	if (!Suru.track.digitalData.page) return false;
	Site.track.trackInfo({
		ajaxURL: '/ajax/product-info/uuid/' + Suru.track.digitalData.page.uuid,
		eventName: 'data-layer-push-ajax-fund', 
		property: 'product'
	})
});
$(document).on('data-layer-push-ajax-fund', Suru.track.pushData);


